import Ajv from 'ajv';
export const ajv = () => new Ajv({ strict: false });
export default ajv;
